import styled from 'styled-components';

export const Main = styled.main`
  background: ${({ theme }) => theme.colors.neutral.neutral10};
`;
